require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');
require('../../../assets/lib/imageCropper/cropper.min.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');
require('../../../assets/lib/fileuploader/fileuploader.js');
require('../../../assets/lib/ngStorage/ngStorage.min.js');

require('../../../assets/stylekit/js/jv.Tooltip.js');
require('../../../assets/stylekit/js/jv.Breadcrumbs.js');
require('../../../assets/scripts/myaccount/jv.Breadcrumbs.webpack.js');

require('../../../assets/scripts/common/polyfills.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/jv.ImageCropper.js');
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/common/directives/jv.EditableButtons.Dir.js');
require('../../../assets/scripts/common/directives/jv.ImageUploader.js');
require('../../../assets/scripts/common/jv.responsive.js');
require('../../../assets/scripts/common/jv.Facebook.js');
require('../../../assets/scripts/common/jv.DocuSignAuth.Svc.webpack.js');
require('../../../assets/scripts/common/directives/jv.Tinymce.webpack.js');
require('../../../assets/scripts/common/jv.Position.js');
require('../../../assets/scripts/common/directives/jv.ShowPosition.js');
require('../../../assets/scripts/common/directives/jv.HideOnBlur.js');
require('../../../assets/scripts/common/directives/jv.root-modal.directive.js');
require('../../../assets/scripts/common/directives/jv.AjaxSelect.js');
require('../../../assets/scripts/common/directives/jv.simple-select.directive.js');
require('../../../assets/scripts/common/jv.ScrollIntoView.js');

require('../../../assets/scripts/admin/users/jv.Admin.Users.EmployeeSelectFAC.js');
require('../../../assets/scripts/admin/users/jv.Admin.Users.Ajax.Factory.js');

require('../../../assets/scripts/myaccount/jv.MyAccount.App.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Svc.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Profile.SVC.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Breadcrumb.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Navigation.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.PersonalTemplates.Controller.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.EditPersonalTemplate.Controller.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Notification.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Preference.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Profile.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Profile.AlternateApprovers.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.Profile.OutofOffice.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.AuthApps.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.JobAlerts.Ctrl.js');
require('../../../assets/scripts/myaccount/jv.MyAccount.LiRsc.Ctrl.js');

require('../../../assets/scripts/jhire/jv.directives.js');
require('../../../assets/scripts/jhire/services/jv.getDeferred.Svc.js');

require('../../../assets/scripts/myaccount/jv.AuthApps.Fac.js');
require('../../../assets/scripts/myaccount/jv.AuthApps.Transformations.js');
